const dict = {
  chooseLang: "选择语言",

  //Licence
  instructions: "说明",
  step1: "第一步：扫描二维码",
  locateqr: "找到右侧的二维码。",
  useSmartphone:
    "使用智能手机的相机或二维码扫描应用程序进行扫描。这将带您进入下一步。",
  step2: "第二步：输入播放列表信息",
  afterScan: "扫描二维码后，系统将提示您输入播放列表信息。",
  makeSure: "请确保填写所有必填字段。",
  step3: "第三步：返回应用",
  onceYou:
    "输入播放列表详细信息后，您可以返回应用并继续使用。",
  refresh: "刷新",
  playlist: "播放列表",
  bigPlaylist: "播放列表",
  noLicence: "您没有许可证。",
  scanLicence: "扫描以购买许可证。",
  noPlaylist: "您没有任何播放列表",
  privacyBig: "隐私模式",
  scanToAddBig: "扫描以添加播放列表",
  scanToBuyBig: "扫描以购买许可证",
  orVisit: "或访问",
  andenterdeviceID: "并输入此设备ID：",
  removePlaylist: "删除播放列表",
  wantToRemove: "您确定要删除吗？",
  cancelBig: "取消",
  loading: "加载中...",
  enablePMode: "请启用隐私模式以继续观看。",
  killSwitchProtecting: "当隐私模式关闭时，Kill Switch 会阻止访问以保护您的隐私。",
  kSwitchProtecionActive: "Kill Switch 保护已激活",
  privacyMode: "隐私模式",
  ok: "确定",

  //Home
  bigLiveTv: "直播电视",
  bigMovies: "电影",
  bigSeries: "剧集",
  //Channel-Menu
  noChannels: "此播放列表没有频道数据",
  searchChannels: "搜索频道",
  tapToPlay: "点击播放视频流。",
  categoryEmpty: "此类别为空",
  pinNotSet: "未设置 PIN",
  setPinNow: " 您想现在设置 PIN 吗？",
  preview: "预览",
  liveTv: "直播电视",
  addToFav: "添加到收藏",
  removeFromFav: "从收藏中移除",
  now: "正在播放：",
  nextPlaying: "下一个：",
  channels: "频道",
  noChannelsFound: "未找到频道",

  //Movies
  noMovies: "此播放列表没有电影数据",
  searchMovies: "搜索电影",
  noFavMovies: "没有收藏的电影",
  //series
  noSeries: "此播放列表没有剧集数据",
  searchSeries: "搜索剧集",
  noFavSeries: "没有收藏的剧集",
  search: " 搜索",
  thereIsProblem: "目前出现了问题",
  tryAgainLater: "请稍后再试。",
  series: "剧集",
  movies: "电影",
  noSeriesFound: "未找到剧集",
  noMoviesFound: "未找到电影",
  //entity
  play: "播放",
  playMovie: "播放电影",
  recommendations: "推荐",
  //User Info
  userInfo: "用户信息",
  aboutApp: "关于应用",
  //Userinfo
  account: "账户",
  subscriptions: "订阅",
  privacyPilicy: "隐私与政策",
  languge: "语言",
  english: "英语",
  italian: "意大利语",
  german: "德语",
  spanish: "西班牙语",
  french: "法语",
  saudiArabia: "阿拉伯语",
  change_pin: "更改 PIN",
  kill_switch: "Kill Switch",
  device_info: "设备信息",
  unknown: "未知",

  //headers
  settings: "设置",
  termsConditions: "条款与条件",
  home: "主页",

  //license
  scanQrCode: "扫描二维码发送播放列表",
  managePlaylist: "管理播放列表",
  orVisitt: "或访问",
  scanToAdd: "扫描以添加播放列表或访问",

  //device info
  display: "显示",
  storage: "存储",
  network: "网络",
  connection: "连接",
  macAddress: "MAC 地址：",
  deviceId: "设备 ID：",
  pmInfo: "隐私模式信息",
  statusActive: "状态：活跃",
  underMaintance: "状态：维护中",
  version: "版本：",
  lastBuildDate: "最后构建日期：",
  lastUpdated: "最后更新：",

  //kill switch
  enableKillSwitch: "启用 Kill Switch？",
  disableKillSwitch: "禁用 Kill Switch？",
  whenEnabled: "启用后，OrbixPlay 仅在隐私模式开启时运行。",
  withOrWithoutPM: "无论隐私模式是否开启，OrbixPlay 都将正常运行。",
  extra_privacy_protection: " 额外隐私保护",
  pmOn: "• 隐私模式开启：您可以安全地流媒体内容",
  killSwitchDescription: "Kill Switch 提供额外的保护层以实现最大隐私。",
  pmOff: "• 隐私模式关闭：应用将阻止访问以保护您的隐私",
  reenable: "您可以随时重新启用以获得最大安全性。",
  cancel: "取消",
  enable: "启用",
  disable: "禁用",
  killSwitch: "Kill Switch – 额外隐私保护",
  ipHidden: "开启隐私模式后，您的 IP 地址将被隐藏，连接通过安全系统传输——类似于 VPN 的工作方式。",
  extraLayer: "Kill Switch 是额外的保护层：启用后，OrbixPlay 仅在隐私模式开启时运行。",
  ifPmOn: "• 隐私模式开启：您可以安全地流媒体内容",
  ifPmOff: "• 隐私模式关闭：应用将阻止访问以保护您的隐私",
  recommended: "推荐给希望获得最大安全性、且不希望在无保护情况下流媒体的用户。",
  current_status: "当前状态：",
  pressToDisable: "🛡️ 已启用 - 按下以禁用",
  pressToEnable: "○ 已禁用 - 按下以启用",
  pressEnter: " 按上方按钮的 Enter 键以更改 Kill Switch 设置",

  //set pin
  pinSetSuccessfully: "PIN 设置成功！",
  createPin: "创建您的 PIN",
  confirmPin: "确认您的 PIN",
  confirmYourPin: "confirmPin: '确认您的 PIN'",
  initializingPin: "正在初始化 PIN 设置...",
  enterCurrentPin: "输入当前 PIN",
  enterNewPin: "输入新 PIN",
  confirmNewPin: "确认新 PIN",
  pinChanged: "PIN 更改成功！",
  pinHasChanged: " 您的 PIN 已成功更改！",

  //lastones
  playInfo: "播放列表信息",
  playName: "播放列表名称：",
  host: "主机：",
  username: "用户名：",
  password: "密码：",
  packName: "套餐名称：",
  expireDate: "到期日期：",

  //privacyPolicy
  one: "1. 内容免责声明：OrbixPlay 是一个旨在提升您数字体验的平台。但需要注意的是，OrbixPlay 不托管、提供或分发视频内容。我们的服务旨在支持您的数字旅程，但我们不对视频材料的可用性、质量或内容承担责任，因为这超出了我们服务的范围。",
  two: "2. 对第三方内容不承担责任：OrbixPlay LLC 对您通过我们应用程序访问的任何第三方内容不承担责任。您与任何外部内容的互动，包括其合法性、可靠性或适当性，完全由您自行承担风险。",
  three:
    "3. 司法管辖区和合规性：OrbixPlay LLC 在美国司法管辖区内运营。用户有责任确保其使用该应用程序符合所有地方、州和联邦法律。",
  four: "4. 定价政策：OrbixPlay 服务的价格可能随时更改，恕不另行通知。接受本协议即表示您承认并同意价格可能有所变化，且此类变化在您的订阅续期之前不会影响您当前的服务。",
  five: `5. 无保证：OrbixPlay 应用程序及其服务按"现状"提供，不附带任何明示或暗示的保证，包括但不限于适销性、特定用途适用性和不侵权的暗示保证。`,
  six: "6. 条款接受：点击同意即表示您同意受本免责声明条款的约束，并承认任何违规行为可能导致您访问 OrbixPlay 服务被终止。",
  orbixUserAgreement: "ORBIXPLAY 用户协议与免责声明",
  beforeyouProcc: "在继续之前，请阅读并接受以下条款和条件：",

  //additional
  exitApp: "退出 OrbixPlay",
  wantToExit: "您确定要退出 OrbixPlay 吗？",
  Resume: "继续",

  whatsnewinv: "版本新功能 v",
  whatsnew: "新功能",

  resellerInfiniteDevices: "经销商计划：无限设备",
  resellerInfiniteDevicesDesc: "同一个播放列表现在可以安装在无限台设备上——不是5台，也不是10台，而是您需要的任意数量。",
  thankyouforusingorbixplayenjoythenewfeatures: "感谢您使用 OrbixPlay——尽情体验新功能吧！",

  instanthomescreen: "继续观看",
  instanthomescreendesc: "从上次停止的地方继续观看剧集和电影。",
  turbomoviesearch: "收藏功能",
  turbomoviesearchdesc: "保存您喜爱的内容以便随时快速访问。",
  lighterondataandbattery: "增强播放器稳定性",
  lighterondataandbatterydesc: "改善播放可靠性和更流畅的快进/快退操作。",
  underthehoodfixes: "底层修复",
  underthehoodfixesdesc: "各种错误修复和性能改进，带来更好的体验。",

  proxyMaintenance: '代理维护',
  proxyMaintenanceMessage: '代理服务器目前正在维护中。请稍后再试。',

  playlistInformation: '播放列表信息',
  playlistExpDate: '播放列表到期日期：',

  select_playlist: "选择播放列表",
  choose_playlist: "选择一个播放列表开始观看",
  invalid_line: "无效链路",
  expire_date: "到期日期：",
  expired: "已过期",
  waiting_connection: "等待连接中...",
  reconnection_attempt: "重新连接尝试",
  try_again: "重试",
  go_back: "返回",
  unable_to_resume: "无法恢复",
  reconnecting: "重新连接中...",
  no_internet_connection: "无互联网连接",
  please_try_again: "无法重新启动流。请重试。",
  restore_stream: "请稍候，我们正在恢复您的直播。",
  reconnect_automatically: "请检查您的网络，我们将自动重新连接。",
  check_wifi: "请检查您的 WiFi 连接",
  check_ethernet: "请检查您的以太网 / LAN 连接",
  check_internet: "请检查您的互联网连接",

  add_playlist_screen: "添加播放列表",
  add_playlist: "手动添加播放列表",
  playlist_name_required: "播放列表名称为必填项",
  m3u_url_required: "M3U 播放列表 URL 为必填项",
  server_url_required: "服务器 URL 为必填项",
  username_required: "用户名为必填项",
  password_required: "密码为必填项",
  orbix_code_required: "Orbix 主机代码为必填项",
  list_code_required: "列表代码为必填项",
  device_id_required: "设备 ID 为必填项",
  device_id: "设备 ID：",
  playlist_format: "播放列表格式",
  m3u: "M3U URL",
  username_password: "用户名 / 密码",
  orbix_code: "Orbix 代码",
  list_code: "列表代码",
  playListName: "播放列表名称 *",
  m3uUrl: "M3U 播放列表 URL *",
  server_URL: "服务器 URL *",
  username_req: "用户名 *",
  password_req: "密码 *",
  orbix_code_req: "Orbix 主机代码 *",
  list_code_req: "列表代码 *",
  addPlaylist: "添加播放列表",
  adding: "正在添加...",
  my_playlist: "我的播放列表",
  username_placeholder: "用户名",
  password_placeholder: "••••••••",

  //stream exceptions
  stream_extension: "流扩展",

  //storage_and_data
  storage_and_data: "存储与数据",

  // ── Parental PIN ──────────────────────────────────────────────────────────
  enter_parental_pin: "输入家长PIN",

  // ── Account / Subscriptions labels ───────────────────────────────────────
  status: "状态",
  active: "活跃",
  expiration: "到期",
  max_connections: "最大连接数",
  one_device: "1台设备",
  created: "创建于",

  // ── Storage & Data screen ─────────────────────────────────────────────────
  section_title: "存储与数据",
  section_subtitle: "管理应用存储的数据",
  favourites_label: "收藏夹",
  history_label: "观看历史",
  cleared_label: "已清除",
  all_cleared_label: "全部清除",
  remove_cancel_label: "取消",
  remove_confirm_label: "清除",
  clear_fav_channels_title: "收藏频道",
  clear_fav_channels_subtitle: "移除所有已保存的频道",
  clear_fav_channels_message: "清除所有收藏频道？",
  clear_fav_movies_title: "收藏电影",
  clear_fav_movies_subtitle: "移除所有已保存的电影",
  clear_fav_movies_message: "清除所有收藏电影？",
  clear_fav_series_title: "收藏剧集",
  clear_fav_series_subtitle: "移除所有已保存的剧集",
  clear_fav_series_message: "清除所有收藏剧集？",
  clear_continue_watching_movies_title: "继续观看 – 电影",
  clear_continue_watching_movies_subtitle: "删除电影观看进度",
  clear_continue_watching_series_title: "继续观看 – 剧集",
  clear_continue_watching_series_subtitle: "删除剧集观看进度",
  clear_continue_watching_title: "继续观看",
  clear_continue_watching_message: "清除观看历史？",
  clear_all_title: "清除所有数据",
  clear_all_message: "这将清除所有收藏和观看历史。",

  // ── Stream Extension screen ───────────────────────────────────────────────
  stream_extension_desc: "选择从服务器请求直播流的方式。",
  ts_desc: "标准MPEG-TS流",
  m3u8_desc: "HLS自适应流",
  current: "当前",

  // ── Kill Switch modal ─────────────────────────────────────────────────────
  access_restricted: "🛡️ 访问受限",
  to_access_playlists: "访问播放列表：",
  enable_privacy_mode_step: "1. 从主屏幕启用隐私模式",
  disable_kill_switch_step: "2. 或在设置 → Kill Switch 中禁用Kill Switch",
  preparingContent: "正在准备内容",

  // ── Home screen ──────────────────────────────────────────────────────────────
  loading_base: "加载中",
  live_now: "正在直播",
  news: "新闻",
  sport: "体育",
  kids: "儿童",

  // ── Series details ───────────────────────────────────────────────────────────
  episode: "集",
  no_episodes: "本季暂无可用剧集。",

  searchForChannels: "搜索频道...",
  kbSpace: "空格",
  kbCaps: "大写",
  pressOkToPlay: "按OK播放",
  live: "直播",
};

export default dict;